const FOCUSABLE_SELECTOR =
  'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

export function getFocusableElements(container: HTMLElement): HTMLElement[] {
  return Array.from(container.querySelectorAll<HTMLElement>(FOCUSABLE_SELECTOR)).filter(
    (el) => !el.hasAttribute('disabled') && el.tabIndex !== -1,
  );
}

export function focusFirstFocusable(container: HTMLElement): void {
  const focusables = getFocusableElements(container);
  if (focusables.length > 0) {
    focusables[0]!.focus();
    return;
  }
  if (container.tabIndex < 0) container.tabIndex = -1;
  container.focus();
}
